import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  track: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
});

export default styles;
